import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import swal from "sweetalert";
import Table from "react-bootstrap/Table";
import "./distributorPO.css";

function DistributorPO() {
  const [Porder, setPorder] = useState([]);
  const [, setPorder1] = useState([]);
  const [CPO, setCPO] = useState([]);
  const [distributorName] = useState("");
  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      setPorder(response.data);
    });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setPorder1(response.data);
    });
  }, []);

  const handleInputChange = (sku, column, value) => {
    const index = Porder.findIndex((row) => row.sku === sku);
    const newTableData = [...Porder];
    newTableData[index][column] = value;

    if (column === "discount") {
      newTableData[index].total = (value / 100) * newTableData[index].price;
      newTableData[index].PurchaseValue =
        newTableData[index].price - newTableData[index].total;
    }

    if (column === "quantity1") {
      newTableData[index].OrderValue =
        newTableData[index].quantity1 * newTableData[index].PurchaseValue;
    }

    newTableData[index].distributorName = distributorName;


    const newTableDataArray = Object.values(newTableData);

    setPorder(newTableDataArray);
  };

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const selectedlist = Porder.find((listdata) => listdata.sku === value);

    if (event.target.checked) {
      setCPO([...CPO, selectedlist]);
    } else {
      setCPO(CPO.filter((listdata) => listdata.sku !== selectedlist.sku));
    }
  };

  function handleSubmit() {
    Axios.post(`${INVENTORY_API_BASE_URL}/postPurchase`, CPO)
      .then((result) => {
      })
      .catch((error) => {
      });
    swal({
      title: "Order Created",
      text: "",
      icon: "success",
    });
  }

  return (
    <div className="cpo">
      <h4 className="cpoh">Create Distributor Order</h4>

      <Table responsive size="sm" className="createtablecpo">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>SKU</th>
            <th>Image</th>
            <th>Title</th>
            <th>Medium</th>
            <th>Publication Date</th>
            <th>Edition</th>
            <th>Current Stock</th>

            <th>MRP</th>

            <th>Discount</th>
            <th>Discount Value</th>
            <th>Purchase Price</th>
            <th>Order Quantity</th>
            <th>Order Value</th>
          </tr>
        </thead>

        <tbody>
          {Porder.map((row) => (
            <tr key={row.sku}>
              <td></td>
              <td>
                <input
                  type="checkbox"
                  name="listdata"
                  value={row.sku}
                  onChange={handleCheckboxChange}
                  checked={CPO.some(
                    (selectedlist) => selectedlist.sku === row.sku
                  )}
                />
              </td>
              <td>{row.sku}</td>
              <td>
                <img
                  src={`https://d10idqgatxnd06.cloudfront.net/${row.img}`}
                  width="70"
                  height="70"
                  alt={"bookimage"}
                />
              </td>
              <td>{row.title}</td>
              <td>{row.Medium}</td>
              <td>{row.date}</td>
              <td>{row.edition}</td>
              <td>
                <input
                  type="number"
                  value={row.currentstocks}
                  onChange={(e) =>
                    handleInputChange(row.sku, "currentstocks", e.target.value)
                  }
                />
              </td>

              <td>{row.price}</td>

              <td>
                <input
                  type="number"
                  value={row.discount}
                  onChange={(e) =>
                    handleInputChange(row.sku, "discount", e.target.value)
                  }
                />
              </td>
              <td>{row.total || row.discount * row.price}</td>
              <td>{row.PurchaseValue}</td>
              <td>
                <input
                  type="number"
                  value={row.quantity1}
                  onChange={(e) =>
                    handleInputChange(row.sku, "quantity1", e.target.value)
                  }
                />
              </td>
              <td>{row.OrderValue}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div>
        <button type="submit" className="cpob1" onClick={handleSubmit}>
          Create Purchase Order
        </button>
      </div>
    </div>
  );
}
export default DistributorPO;
